import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { TriangleAlertIcon } from "lucide-react";

export default function NavTeamPaymentWarning() {
  const { teamSelected, isManager, isAdmin, isBilling } = useTeams();
  const { t } = useTranslation();

  const isPastDue =
    teamSelected?.stripeMonthlySubscriptionStatus === "past_due" ||
    teamSelected?.stripeAnnualSubscriptionStatus === "past_due";

  if (!isPastDue || (!isManager && !isAdmin && !isBilling)) {
    return null;
  }

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Badge variant="warning">
          <TriangleAlertIcon className="w-3 h-3" />
          {t("teamPaymentWarning.label")}
        </Badge>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="end">
        <div className="flex items-center space-x-2">
          <TriangleAlertIcon className="w-4 h-4 text-warning" />
          <div>{t("teamPaymentWarning.tooltip")}</div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
